import React from 'react'
import ANDY_DOG from 'styles/images/andy-dog.jpeg'
import {Carousel} from 'flowbite-react'

const ImgAreaAndy = () => {
  return (
    <div className='max-w-7xl h-[660px] bg-cover bg-no-repeat bg-center rounded m-auto z-10 bg-fixed flex justify-end items-center mt-10 opacity-70'>
      <Carousel slide={true} slideInterval={4000}>
        <img src={ANDY_DOG} alt='IMG ALT' className='hover:cursor-default' />
        <img src={ANDY_DOG} alt='IMG ALT' className='hover:cursor-default' />
        <img src={ANDY_DOG} alt='IMG ALT' className='hover:cursor-default' />
        <img src={ANDY_DOG} alt='IMG ALT' className='hover:cursor-default' />
      </Carousel>
    </div>
  )
}

export default ImgAreaAndy
